export { CRMHeader, type CRMHeaderProps } from './CRMHeader.tsx';
